import { Component, ViewEncapsulation } from '@angular/core';
import { MSC_SEVERITY_LEVEL_CONTACTS } from './data/msc-severity-level-contacts';
import { NOC_SEVERITY_LEVEL_CONTACTS } from './data/noc-severity-level-contacts';

@Component({
  selector: 'app-noc-policy',
  templateUrl: './noc-policy.component.html',
  styleUrls: ['./noc-policy.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NocPolicyComponent {
  readonly nocSeverityLevelContacts = NOC_SEVERITY_LEVEL_CONTACTS;

  readonly mscSeverityLevelContacts = MSC_SEVERITY_LEVEL_CONTACTS;
}
